import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { type SchemaFieldRecord } from "../TopicRecord";

/**
 * Every field a topic schema declares, structs and their children alike.
 * Schemas are content-addressed, so a schema's fields never change and a
 * cached read never goes stale.
 */
export function useSchemaFields(
  schemaId: string,
  orgId: string,
): UseQueryResult<SchemaFieldRecord[], Error> {
  const { topics: topicService } = useDomainServices();
  return useQuery<SchemaFieldRecord[], Error>({
    queryKey: ["schemaFields", orgId, schemaId],
    queryFn: ({ signal }) =>
      topicService.getSchemaFields(schemaId, {
        abortSignal: signal,
        resourceOwnerId: orgId,
      }),
    staleTime: Infinity,
  });
}
